import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { LoadingCircle } from '../../components/common/loading';

class PortfolioRedirect extends Component {

  render = () => {
      return (
        <div>
            <LoadingCircle/>
            </div>
      );
  }

}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
  },
})(PortfolioRedirect);
